import React from "react";
import "./style.css";

const ViewAllButton = () => {
  return (
    <button className="view_all_tik_event_btn">
      View all tickets & events{" "}
      <span>
        <svg
          width="30"
          height="29"
          viewBox="0 0 30 29"
          fill="none"
        >
          <g clipPath="url(#clip0_519_580)">
            <path
              d="M22.0713 21.9289L29.1424 14.8578L22.0713 7.78676L21.1875 8.67064L26.7463 14.2294L1.52106 14.2363V15.4793L26.7463 15.4862L21.1875 21.045L22.0713 21.9289Z"
              fill="#222539"
            />
          </g>
        
        </svg>
      </span>
    </button>
  );
};

export default ViewAllButton;
